import { usePostHttp } from "../../http.hook";
import type { ICSVUpload } from "./add-new-csv-favorite-collection.admin.http";



interface IResponse {
  csvLog: ICSVUpload;
}

export function useCsvRetryAllAdminHttp() {
  return usePostHttp<null, IResponse>({
    path: "/admin/favourite-socials/csv/:id/retry-all",
  });
}
